import { render, staticRenderFns } from "./ProductFlags.vue?vue&type=template&id=ec87bac0&scoped=true&name=product-flags&"
import script from "./ProductFlags.vue?vue&type=script&lang=js&"
export * from "./ProductFlags.vue?vue&type=script&lang=js&"
import style0 from "./ProductFlags.vue?vue&type=style&index=0&id=ec87bac0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec87bac0",
  null
  
)

export default component.exports